import React, { Dispatch } from 'react';
import { TQuestion } from '../types';
import { Stack, TableCell } from '@mui/material';
import { classes } from '../../Components/GenericTable/styles';
import moment from 'moment-timezone';
import { getKeyByValue } from './Modals/NewQuestion';
import { fieldTypeValues } from '../config';
import { GenericTableAction } from '../../Components/GenericTable/genericTableReducer';
import { TSortableColumn } from '../../Components/GenericTable/types';

const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const QuestionsTableRow = ({
  column,
  item,
  tableHovered,
  dispatch
}: {
  column: TSortableColumn;
  item: TQuestion;
  tableHovered: boolean;
  dispatch?: Dispatch<GenericTableAction<TQuestion>>;
}) => {
  if (!column.enabled) return null;

  const handleClick = () => {
    if (!dispatch) return;
    dispatch({
      type: 'SELECT_ACTION_ITEM',
      payload: { item, name: 'edit', anchorEl: null }
    });
  };

  switch (column.id) {
    case 'name':
      return (
        <TableCell
          key={item.id + column.id}
          sx={{
            ...classes.sticky,
            ...classes.idTableCell,
            minWidth: '150px',
            left: '0px'
          }}
        >
          <Stack
            sx={{ fontWeight: 'bold', cursor: 'pointer', width: 'fit-content' }}
            onClick={handleClick}
          >
            {item.library_field_name}
          </Stack>
        </TableCell>
      );
    case 'type':
      return (
        <TableCell
          key={item.id + column.id}
          sx={{
            ...classes.sticky,
            ...classes.itemTitleTableCell,
            ...(tableHovered && classes.scrollShadowVisible),
            left: '150px',
            minWidth: '100px'
          }}
        >
          {getKeyByValue(fieldTypeValues, item.field_type)}
        </TableCell>
      );
    case 'created_by':
      return <TableCell key={item.id + column.id}>{item.created_by}</TableCell>;
    case 'updated_by':
      return <TableCell key={item.id + column.id}>{item.updated_by || '-'}</TableCell>;
    case 'created_at':
      return (
        <TableCell key={item.id + column.id}>
          {item.created_at
            ? moment.tz(item.created_at, browserTimezone).format('D MMM YYYY, hh:mma z')
            : '-'}
        </TableCell>
      );
    case 'updated_at':
      return (
        <TableCell key={item.id + column.id}>
          {item.updated_at
            ? moment.tz(item.updated_at, browserTimezone).format('D MMM YYYY, hh:mma z')
            : '-'}
        </TableCell>
      );
    default:
      return <TableCell></TableCell>;
  }
};

export default QuestionsTableRow;
